'use client'

import { useEffect } from 'react'

/**
 * Component that registers the service worker for push notifications
 * on app mount. Uses the service worker provided by @xtr-dev/payload-notifications.
 */
export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!('serviceWorker' in navigator)) {
      console.warn('Service workers are not supported in this browser')
      return
    }

    // Register the service worker provided by the notifications plugin
    navigator.serviceWorker
      .register('/sw-notifications.js')
      .then((registration) => {
        console.log('Service worker registered successfully:', registration.scope)
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error)
      })
  }, [])

  return null // This component doesn't render anything
}
